import { CircularProgress } from '@mui/material';
import { FC } from 'react';
import { Logo } from './Logo';

type Props = {
  content?: React.ReactNode;
};

export const FullPageProgress: FC<Props> = ({ content }) => (
  <div className="absolute w-screen h-screen z-10 flex flex-col justify-center items-center">
    <div className="bg-gray-100 opacity-90 w-full h-full"></div>
    <div className="absolute flex flex-col items-center justify-center">
      <div className="mb-2">
        <Logo />
      </div>

      <CircularProgress
        sx={{ color: '#333' }}
        size={40}
        thickness={5}
        className="mb-4"
      />
      <div>{content}</div>
    </div>
  </div>
);
